<template>
	<div>Attend page</div>
</template>

<script>
export default {};
</script>

<style></style>
